import type { Glyph } from "./types";

export const PlusIcon: Glyph = (props) => (
  <svg viewBox="0 0 50 50" aria-hidden="true" fill="currentColor" {...props}>
    <path d="M24.1 45.116L24.1 4.885C24.1 4.388 24.503 3.985 25 3.985C25.497 3.985 25.901 4.388 25.901 4.885L25.901 45.116C25.901 45.613 25.497 46.015 25 46.015C24.503 46.015 24.1 45.613 24.1 45.116Z" />
    <path d="M45.121 24.105C45.618 24.105 46.02 24.508 46.02 25.005C46.02 25.502 45.618 25.906 45.121 25.906L4.88 25.906C4.383 25.906 3.98 25.502 3.98 25.005C3.98 24.508 4.383 24.105 4.88 24.105L45.121 24.105Z" />
  </svg>
);

export default PlusIcon;
